import React from "react";

// Crisp inline SVG monogram — engineered, clinical feel
export const LogoMark = ({ className = "", stroke = "#0B192C" }) => (
  <svg
    viewBox="0 0 44 44"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect x="1" y="1" width="42" height="42" stroke={stroke} strokeWidth="1.4" />
    {/* M */}
    <path d="M8 31V13L15 24L22 13V31" stroke={stroke} strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
    {/* D */}
    <path d="M27 13H31C35 13 37 16.5 37 22C37 27.5 35 31 31 31H27V13Z" stroke={stroke} strokeWidth="2" strokeLinejoin="round" />
  </svg>
);

export const Logo = ({ light = false, className = "" }) => {
  const color = light ? "#FFFFFF" : "#0B192C";
  const sub = light ? "#93b4d0" : "#64748b";
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <LogoMark className="h-9 w-9 shrink-0" stroke={color} />
      <div className="leading-none">
        <div
          className="font-display text-[19px] font-extrabold tracking-[0.14em]"
          style={{ color }}
        >
          MD&nbsp;LABS
        </div>
        <div
          className="text-[9px] font-semibold uppercase tracking-[0.32em] mt-1"
          style={{ color: sub }}
        >
          Medical Device Mfg.
        </div>
      </div>
    </div>
  );
};

export default Logo;
